/**
 * Created by lu on 2018/4/24.
 */
var nb = require('../nb');
var $ = nb.opts.$;
require('../localization/cn');
require('../localization/en');
var Model = nb.define({
    parent: nb.Model,
    method: {
        init: function () {

        },
        setData:function (inKey) {
            this.setOpts(localization[inKey]);
        }
    }
});
var model = new Model;
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/Language.js
// module id = 14
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39